import {
  CREATECERTIFICATETEMPLATE,
  GETCERTIFICATETEMPLATE,
  DELETECERTIFICATETEMPLATE,
  UPDATECERTIFICATETEMPLATE,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETCERTIFICATETEMPLATE:
      return {
        ...state,
        certificatetemplateList: action.payload.data,
      };
    case UPDATECERTIFICATETEMPLATE:
      return {
        ...state,
        certificatetemplateUpdateStatus: action.payload.success,
      };

    case DELETECERTIFICATETEMPLATE:
      return {
        ...state,
        certificatetemplateDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
